import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ItemProdutoListarComponent } from "./item-produto-listar.component";
import { ItemProdutoListarRoutingModule } from "./item-produto-listar-routing.module";

import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { MessagesModule } from "primeng/messages";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { ProgressSpinnerModule } from "primeng/progressspinner";


@NgModule({
    imports: [
        CommonModule,
        ItemProdutoListarRoutingModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        ConfirmDialogModule,
        DropdownModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [ItemProdutoListarComponent]
})
export class ItemProdutoListarModule { }
